export class ActivityLevelModel {
  constructor(
    private engName: string,
    private name: string,
    private description: string,
    private id: number,
    private img: string
  ) {}

  public getName() {
    return this.name;
  }

  public getDescription() {
    return this.description;
  }

  public getID() {
    return this.id;
  }

  public getEngName() {
    return this.engName;
  }

  public getImg() {
    return this.img;
  }
}

const Sedentary = new ActivityLevelModel(
  'sedentary',
  'خیلی کم',
  'بدون تحرک (ناتوان حرکتی)',
  0,
  'assets/general/logo.png'
);
const Light = new ActivityLevelModel(
  'light',
  'کم',
  'فعالیت کم روزمره (کارمند یا خانه‌دار)',
  1,
  'assets/general/logo.png'
);
const Moderate = new ActivityLevelModel(
  'moderate',
  'متوسط',
  'روزانه یک ساعت ورزش سبک (پیاده‌روی)',
  2,
  'assets/general/logo.png'
);
const Active = new ActivityLevelModel(
  'active',
  'زیاد',
  'روزانه دو ساعت ورزش سنگین (شنا)',
  3,
  'assets/general/logo.png'
);
const Extreme = new ActivityLevelModel(
  'extreme',
  'خیلی زیاد',
  'هر روز ورزش حرفه‌ای (فوتبال)',
  4,
  'assets/general/logo.png'
);

export const ActivityLevels = [Sedentary, Light, Moderate, Active, Extreme];
